import { gql } from "@apollo/client";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import { useResettableMutation } from "../useResettableMutation";
import { AddAdminRole, AddAdminRoleVariables } from "./__generated__/AddAdminRole";

const ADD_ADMIN_ROLE = gql`
  mutation AddAdminRole($displayName: String!, $organizationId: String!, $permissionNames: [String!]) {
    addAdminRole(
      input: { displayName: $displayName, organizationId: $organizationId, permissionNames: $permissionNames }
    ) {
      adminRoleId
    }
  }
`;

export function useAddAdminRole() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation<AddAdminRole, AddAdminRoleVariables>(
    ADD_ADMIN_ROLE,
    {
      errorPolicy: "all",
    }
  );
  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}
